import React from "react";
import Label from "reactstrap/es/Label";
import _ from "lodash";
import { getZh } from "../../../constants/general";
import InputNumber from "../../betting/InputNumber";

const LottoBettingBoardMobile = ({ useHook, priceKey, wrapperClass = "" }) => {
    const ctx = useHook();
    if (!ctx) return null;

    const {
        t,
        i18n,
        config,
        posts,
        betTypes,
        activeBetType,
        fields,
        isBetting,
        activeNumberField,

        // handlers from wrapper (Lotto90 or Lotto99)
        handlePostCheckChange,
        handleBetTypeChange,
        setActiveNumberField,
        handleDigitClick,
        handleChangeField,
        handlePriceClick,
        handleSubmitBetting,
        resetBet,
    } = ctx;

    const isZh = i18n.language === "zh";
    const priceList = config?.[priceKey] || [];
    const betAmountInt = parseInt(fields.betAmount || 0, 10);

    const hasValidBet =
        betAmountInt > 0 && !_.isEmpty(posts.filter((p) => p.checked));

    const digitsRow1 = ["0", "1", "2", "3", "4"];
    const digitsRow2 = ["5", "6", "7", "8", "9"];

    const currentFieldName =
        activeNumberField === "from"
            ? "numberFrom"
            : activeNumberField === "to"
                ? "numberTo"
                : "betAmount";

    return (
        <div
            className={`form-betting w-right bg-grey pr-1 pl-1 ${wrapperClass}`}
        >
            {/* POSTS ROW (A B C D E ALL) */}
            <div className=" d-flex w-100">
                {posts.map((p) => (
                    <button
                        key={p.id}
                        type="button"
                        onClick={() => handlePostCheckChange(p.id)}
                        className={`num-pad-btn post flex-fill mr-1 ${
                            p.checked ? "post-active" : ""
                        }`}
                    >
                        {p.id}
                    </button>
                ))}
                <button
                    type="button"
                    onClick={() => handlePostCheckChange("all")}
                    className={`num-pad-btn post flex-fill ${
                        posts.every((p) => p.checked) ? "post-active" : ""
                    }`}
                >
                    ALL
                </button>
            </div>

            {/* BET TYPE ROW */}
            <div className=" d-flex ml-auto w-50">
                {betTypes.map((bt) => (
                    <button
                        key={bt.id}
                        type="button"
                        onClick={() => handleBetTypeChange(bt.id)}
                        className={`num-pad-btn post type mr-1 flex-fill ${
                            activeBetType === bt.id ? "post-active" : ""
                        }`}
                    >
                        {bt.title}
                    </button>
                ))}
            </div>

            {/* NUMBER INPUTS + BET AMOUNT */}
            <div className=" w-100 d-flex flex-column ml-auto">
                <Label className="px-4 f-bold ml-auto">
                    {t("labels:ticket.bet_amount")}
                </Label>

                <div className="d-flex justify-content-end w-100 mr-mo">
                    {/* numberFrom */}
                    <InputNumber
                        name="numberFrom"
                        maxLength="2"
                        value={fields.numberFrom}
                        width="20vw"
                        className="form-control num-pad-btn mr-2"
                        onChange={(e) =>
                            handleChangeField("numberFrom", e.target.value)
                        }
                        onFocus={() => setActiveNumberField("from")}
                    />

                    {/* numberTo (only for RANGE) */}
                    {activeBetType === "RANGE" && (
                        <InputNumber
                            name="numberTo"
                            maxLength="2"
                            value={fields.numberTo}
                            width="20vw"
                            className="form-control num-pad-btn mr-2"
                            onChange={(e) =>
                                handleChangeField("numberTo", e.target.value)
                            }
                            onFocus={() => setActiveNumberField("to")}
                        />
                    )}

                    {/* Bet Amount (read-only, keypad + price buttons control it) */}
                    <div className="d-flex align-items-center mb-2">
                        <input
                            type="text"
                            className="form-control num-pad-btn"
                            value={fields.betAmount}
                            readOnly
                            onFocus={() => setActiveNumberField("amount")}
                        />
                    </div>
                </div>
            </div>

            {/* NUMPAD */}
            <div className="lo90-numpad">
                {/* row 1: 0–4 */}
                <div className="d-flex mb-2">
                    {digitsRow1.map((d) => (
                        <button
                            key={d}
                            type="button"
                            className="num-btn flex-fill num-pad-btn"
                            onClick={() => handleDigitClick(d)}
                        >
                            {d}
                        </button>
                    ))}
                </div>

                {/* row 2: 5–9 */}
                <div className="d-flex mb-2">
                    {digitsRow2.map((d) => (
                        <button
                            key={d}
                            type="button"
                            className="num-btn flex-fill num-pad-btn"
                            onClick={() => handleDigitClick(d)}
                        >
                            {d}
                        </button>
                    ))}
                </div>

                {/* backspace */}
                <div className="d-flex">
                    <button
                        type="button"
                        className="num-btn flex-fill num-pad-btn backspace"
                        onClick={() => {
                            const current =
                                fields[currentFieldName]?.toString() || "";
                            handleChangeField(
                                currentFieldName,
                                current.slice(0, -1)
                            );
                        }}
                    >
                        ←
                    </button>
                </div>
            </div>

            {/* PRICE BUTTONS */}
            <div className="w-100">
                <div className="price-wrapper-lotto90 w-100">
                    {priceList.map((p, i) => (
                        <button
                            key={i}
                            type="button"
                            onClick={() => handlePriceClick(p)}
                            className="post num-pad-btn price"
                        >
                            {isZh ? getZh[p.value] : p.label}
                        </button>
                    ))}
                </div>
            </div>

            {/* BOTTOM ACTION BUTTONS */}
            <div className="d-flex">
                <button
                    type="button"
                    className="btn btn-danger lo90-bottom-btn num-pad-btn m-btn-mo"
                    disabled={isBetting}
                    onClick={resetBet}
                >
                    {t("buttons:clear")}
                </button>
                <button
                    type="button"
                    className="btn btn-success lo90-bottom-btn num-pad-btn m-btn-mo"
                    disabled={!hasValidBet || isBetting}
                    onClick={handleSubmitBetting}
                >
                    {t("buttons:save")}
                </button>
            </div>
        </div>
    );
};

export default LottoBettingBoardMobile;
